import { createUseStyles } from '@glu/theming';

const styles = ({ mobilegrid: { cellPadding, datarow, focusColor, primaryData } }) => ({
  primaryRow: {
    cursor: 'pointer'
  },
  bulkActionSelect: {
    paddingTop: '1rem',
    verticalAlign: 'top'
  },
  bulkActionSvg: {
    '& input[type="checkbox"] + div svg': {
      width: 16,
      height: 16
    }
  },
  expandoTh: {
    verticalAlign: 'top',
    width: '25px',

    '& svg': {
      fill: datarow.expandIconFill
    }
  },
  subCells: {
    padding: datarow.subCellsPadding
  },
  button: {
    background: 'none',
    border: 0,
    padding: 0,
    '&:focus': {
      outlineColor: focusColor
    }
  },
  svg: {
    transition: datarow.contentTransition,
    transform: 'rotate(0)'
  },
  svgOpen: {
    transition: datarow.contentTransition,
    transform: 'rotate(90deg)'
  },
  contentPanelHidden: {
    maxHeight: 0,
    overflow: 'hidden',
    transition: 'max-height 1s ease-in-out'
  },
  contentPanelShown: {
    maxHeight: '100vh',
    overflowX: 'hidden',
    overflowY: 'auto',
    transition: 'max-height 1s ease-in-out'
  },
  mainCells: {
    padding: cellPadding || '0.8em 0',
    fontFamily: primaryData.fontFamily,
    fontWeight: primaryData.fontWeight,
    fontSize: primaryData.cellFontSize || '14px',
    verticalAlign: 'text-top',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '& a:focus': {
      outlineColor: focusColor
    }
  },
  notDate: {
    wordBreak: 'break-word',
    wordWrap: 'break-word'
  },
  rightAlign: {
    paddingLeft: '0px',
    textAlign: 'right'
  },
  leftAlign: {
    paddingLeft: '10px',
    textAlign: 'inherit'
  }
});
export default createUseStyles(styles);
